export default __webpack_public_path__ + "img/BB_NB.849b07bd7c3fdcfe5f7254022f97f702.jpg";